<!-- eslint-disable max-len -->
<template>
  <div
    class="spa-payment-details-form"
  >
    <!-- Disabled temporary until we have a payment form ticket -->
    <!-- <fieldset class="spa-payment-details-form__fieldset">
      <legend>
        {{ tc('spaSoft.step2.paymentInformation.title') }}
      </legend>
      <div class="flex-grid-1-col gutter-md">
        <div class="input card-holder">
          <input
            id="cardHolderName"
            name="cardHolderName"
            type="text"
            class="req"
            :data-val="!disablePaymentValidation"
            :required="!disablePaymentValidation"
            :data-val-required="getValidationForField('required', 'cardHolder')"
            @input="formatCardholder"
            @change="checkIfRequiredFieldsAreFilled"
          >
          <label
            for="cardHolderName"
            class="floating req"
          >{{ tc('spaSoft.step2.paymentInformation.cardHolder') }}
          </label>
          <span
            data-valmsg-for="cardHolderName"
            data-valmsg-replace="true"
            class="field-validation-valid"
          />
        </div>
      </div>
      <div class="flex-grid-2-col gutter-md">
        <div class="input card-number">
          <input
            id="cardNumber"
            name="cardNumber"
            type="text"
            class="req"
            maxlength="16"
            :data-val="!disablePaymentValidation"
            :required="!disablePaymentValidation"
            :data-val-required="getValidationForField('required', 'cardNumber')"
            @input="formatCardNumber"
            @change="checkIfRequiredFieldsAreFilled"
          >
          <label
            for="cardNumber"
            class="floating req"
          >{{ tc('spaSoft.step2.paymentInformation.cardNumber') }}
          </label>
          <span
            data-valmsg-for="cardNumber"
            data-valmsg-replace="true"
            class="field-validation-valid"
          />
        </div>
        <div class="input card-exp">
          <input
            id="cardExpirateDate"
            name="cardExpirateDate"
            type="text"
            class="req"
            :data-val="!disablePaymentValidation"
            :required="!disablePaymentValidation"
            :data-val-required="getValidationForField('required', 'expirationDate')"
            maxlength="5"
            @input="formatCardExpirationDate"
            @change="checkIfRequiredFieldsAreFilled"
          >
          <label
            for="cardExpirateDate"
            class="floating req"
          >{{ tc('spaSoft.step2.paymentInformation.expirationDate') }}
          </label>
          <span
            data-valmsg-for="cardExpirateDate"
            data-valmsg-replace="true"
            class="field-validation-valid"
          />
        </div>
      </div>
    </fieldset> -->
    <SpaTermsAndConditions
      key="spaTermsAndConditions"
      @terms-and-conditions-validation-changed="$emit('terms-and-conditions-validation-changed', $event)"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SpaTermsAndConditions from './spa-terms-and-conditions.vue'

  export default {
    name: 'SpaPaymentDetailsForm',
    components: {
      SpaTermsAndConditions
    },
    inject: ['disablePaymentValidation'],
    computed: {
      ...mapGetters('i18n', ['tc']),
    },
    mounted() {
      this.$nextTick(() => {
        // Disabled temporary until we have a payment form ticket
        // document.getElementById('cardHolderName').focus()
        this.checkIfRequiredFieldsAreFilled()
      })
    },
    methods: {
      getValidationForField(validation, field = '') {
        return this.tc(`validations.${validation}`).replace('{0}', this.tc(`spaSoft.step2.paymentInformation.${field}`))
      },

      formatCardholder(event) {
        const { value } = event.target
        event.target.value = value.replace(/[^A-Za-z\s]/g, '')
      },
      formatCardNumber(event) {
        const { value } = event.target
        event.target.value = value.replace(/\D/g, '')
      },
      formatCardExpirationDate(event) {
        let { value } = event.target
        value = value.replace(/[^0-9/]/g, '')
        if (value.length === 2 && !value.includes('/')) {
          value = `${value}/`
        }
        event.target.value = value
      },

      checkIfRequiredFieldsAreFilled() {
        if (this.disablePaymentValidation) {
          this.$emit('payment-validation-changed', true)
          return
        }
        setTimeout(() => {
          const requiredFieldIds = [
            'cardHolderName',
            'cardNumber',
            'cardExpirateDate',
          ]

          const allFieldsFilled = requiredFieldIds.every((id) => {
            const field = this.$el.querySelector(`#${id}`)
            const hasErrorClass = field && field.classList.contains('input-validation-error')

            return (
              field
              && field.value.trim() !== ''
              && (!hasErrorClass)
            )
          })
          this.$emit('payment-validation-changed', allFieldsFilled)
        }, 300)
      }
    },
  }
</script>
